import { defineComponent as _defineComponent } from 'vue'
import {
  computed, nextTick, ref, useSlots,
} from 'vue';
import {
  scrollToElementTop,
  SCROLL_INTO_VIEW_DURATION_MS,
} from '@/lib/utils/proofreadingEditorUtil';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProofreadingCategoryAccordion',
  props: {
    label: { type: String, required: false },
    defaultOpen: { type: Boolean, required: false },
    scrollToTopOnOpen: { type: Boolean, required: false }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  label?: string;
  defaultOpen?: boolean;
  scrollToTopOnOpen?: boolean;
};



const slots = useSlots();
const hasLeading = computed(() => !!slots['header-leading']);

const rootRef = ref<HTMLElement | null>(null);
const isOpen = ref(props.defaultOpen ?? true);

function toggle() {
  isOpen.value = !isOpen.value;
  if (!isOpen.value || !props.scrollToTopOnOpen) return;

  nextTick(() => {
    if (!rootRef.value) return;
    scrollToElementTop(rootRef.value, SCROLL_INTO_VIEW_DURATION_MS);
  });
}

function open() {
  isOpen.value = true;
}

expose({
  open,
  isOpen,
});

return { __sfc: true,props, slots, hasLeading, rootRef, isOpen, toggle, open }
}

})